import React from 'react'
import Container from '../components/Container'
import { ReactComponent as ServiceIllustration } from '../assets/svg/home_services_illustration.svg'
import Hero from '../components/Hero'
import Card from '../components/Card'
import { ReactComponent as DesignIcon } from '../assets/svg/home_card_design.svg'
import { ReactComponent as GrowthIcon } from '../assets/svg/home_card_growth.svg'
import { ReactComponent as DevelopmentIcon } from '../assets/svg/home_card_development.svg'
import { OfferingContainerProps } from '../types/components'
import { ReactComponent as UXIcon } from '../assets/svg/ux.svg'
import AapnaImg from '../assets/brand/aapna.png'
import CnetricImg from '../assets/brand/cnetric.png'
import RadarSoftImg from '../assets/brand/radarsoft.png'
import { Route, Routes, Link, useNavigate, NavigateFunction } from 'react-router-dom'

function Design() {
    return (
        <div className="space-y-6 md:mt-16 xl:mt-20 3xl:mt-36">
            <div className="capitalize text-themeOrange md:font-bold text-xl md:text-[2.5rem] md:leading-[5rem] xl:text-6xl xl:leading-[5rem] 3xl:text-[5rem]">Design</div>
            <div className="text-[#A3A3A3] font-extrabold text-sm md:text-[1.375rem] md:leading-snug 3xl:text-[2rem] 3xl:leading-normal">
                A design-first service to businesses, products and multiple platforms, we believe that collaboration is the true success. An elegant yet functional product is the perfect combination to approach the market with your vision.
            </div>
            <div className="mt-7 md:mt-16 xl:mt-10 3xl:mt-16">
                <OfferingContainer>Offerings</OfferingContainer>
            </div>
        </div>
    )
}
function Development() {
    return (
        <div className="space-y-6 md:mt-16 xl:mt-20 3xl:mt-36">
            <div className="capitalize text-themeOrange md:font-bold text-xl md:text-[2.5rem] md:leading-[5rem] xl:text-6xl xl:leading-[5rem] 3xl:text-[5rem]">Development</div>
            <div className="text-[#A3A3A3] font-extrabold text-sm md:text-[1.375rem] md:leading-snug 3xl:text-[2rem] 3xl:leading-normal">
                <div className="">Our Technology Partners</div>
                <div className="flex justify-around items-center gap-6 3xl:gap-52 mt-5 md:mt-6 xl:mt-10 3xl:mt-16">
                    <div className="h-8 md:h-12 xl:h-16 3xl:h-20 w-fit flex items-center justify-center bg-gray-200">
                        <img src={AapnaImg} alt="" className="h-full w-auto min-w-[6rem] md:min-w-[10rem] xl:min-w-[16rem] 3xl:min-w-[20rem] bg-white" />
                    </div>
                    <div className="h-8 md:h-12 xl:h-16 3xl:h-20 w-fit flex items-center justify-center bg-gray-200">
                        <img src={CnetricImg} alt="" className="h-full w-auto min-w-[6rem] md:min-w-[10rem] xl:min-w-[16rem] 3xl:min-w-[20rem] bg-white" />
                    </div>
                    <div className="h-8 md:h-12 xl:h-16 3xl:h-20 w-fit flex items-center justify-center bg-gray-200">
                        <img src={RadarSoftImg} alt="" className="h-full w-auto min-w-[6rem] md:min-w-[10rem] xl:min-w-[16rem] 3xl:min-w-[20rem] bg-white" />
                    </div>
                </div></div>
            <div className="mt-7 md:mt-16 xl:mt-10 3xl:mt-16">
                <OfferingContainer>Offerings</OfferingContainer>
            </div>
        </div>
    )
}
function Growth() {

    return (
        <div className="space-y-6 md:mt-16 xl:mt-20 3xl:mt-36">
            <div className="capitalize text-themeOrange md:font-bold text-xl md:text-[2.5rem] md:leading-[5rem] xl:text-6xl xl:leading-[5rem] 3xl:text-[5rem]">Growth</div>
            <div className="text-[#A3A3A3] font-extrabold text-sm md:text-[1.375rem] md:leading-snug 3xl:text-[2rem] 3xl:leading-normal">
                Analysing market gaps, gathering the right community, and strategies to build a base for a global presence is our go-to approach. We build to shape the future of our products and it’s the perfect time that we take the first step together.
            </div>
            <div className="mt-7 md:mt-16 xl:mt-10 3xl:mt-16">
                <OfferingContainer>Offerings</OfferingContainer>
            </div>
        </div>
    )
}

type RouteTypes = 'design' | 'development' | 'growth';

function Services() {

    const url: (RouteTypes | string) = window.location.pathname.split('/')[2]
    const [service, setService] = React.useState<RouteTypes | string>(url !== "" || url ? url : 'design')
    const navigation: NavigateFunction = useNavigate()

    console.log(service)

    React.useEffect(() => {
        if (url === "" || !url) {
            navigation("/services/design")
        }
    }, [])

    return (
        <div>
            <Hero type={'other'}>Services</Hero>

            <Container>
                <div className="py-6 md:py-16 xl:py-24 3xl:py-36">
                    <div className="relative md:pb-44 xl:pb-56">
                        <div className="text-sm md:text-base xl:text-[1.375rem] xl:leading-snug 3xl:text-[2rem] 3xl:leading-snug font-bold md:font-normal text-[#2A2A3E] max-w-md md:max-w-[25.375rem] xl:max-w-2xl 3xl:max-w-4xl">
                            <p>We collaborate with you and your team to empathise, be creative, and run successful Design Sprints to leverage Design Thinking in your product journey!</p>
                            <br />
                            <p>We bring an added flavor to the entire flow, blurring the lines between a life-like offline interaction and a well structured virtual experience.</p>
                        </div>
                        <div className="-mr-6 md:-mr-10 lg:-mr-12 xl:-mr-20 2xl:-mr-24 3xl:mr-[-7.5rem] mt-2 md:absolute md:top-10 md:right-0 xl:-right-6 xl:top-0 3xl:-top-24">
                            <ServiceIllustration className="h-40 md:h-72 xl:h-[27rem] 3xl:h-[39.3125rem] w-auto ml-auto" />
                        </div>
                    </div>
                    <div className="">
                        <div className="">
                            <div className="my-10 grid grid-cols-1 sm:grid-cols-3 gap-4 lg:gap-10 xl:gap-5 2xl:gap-16 max-w-xs sm:max-w-none mx-auto 3xl:hidden">
                                <Link to={"/services/design"}><Card type={'services'} isButtonHidden title={'Design'} icon={<DesignIcon className="h-fit w-[4.125rem] xl:w-[6.25rem] 3xl:w-40" />} isActive={service === 'design'} onClick={() => setService('design')} /></Link>
                                <Link to={"/services/development"}><Card type={'services'} isButtonHidden title={'Development'} icon={<DevelopmentIcon className="h-fit w-[4.25rem] xl:w-[5.75rem] 3xl:w-28" />} isActive={service === 'development'} onClick={() => setService('development')} /></Link>
                                <Link to={"/services/growth"}><Card type={'services'} isButtonHidden title={'Growth'} icon={<GrowthIcon className="h-fit w-[3.75rem] xl:w-[6.25rem] 3xl:w-36" />} isActive={service === 'growth'} onClick={() => setService('growth')} /></Link>
                            </div>
                            <div className="hidden my-10 3xl:grid grid-cols-3 gap-10">
                                <Link to={"/services/design"}><Card type={'large'} isButtonHidden title={'Design'} icon={<DesignIcon className="h-fit w-14" />} isActive={service === 'design'} onClick={() => setService('design')} /></Link>
                                <Link to={"/services/development"}><Card type={'large'} isButtonHidden title={'Development'} icon={<DevelopmentIcon className="h-fit w-16" />} isActive={service === 'development'} onClick={() => setService('development')} /></Link>
                                <Link to={"/services/growth"}><Card type={'large'} isButtonHidden title={'Growth'} icon={<GrowthIcon className="h-fit w-16" />} isActive={service === 'growth'} onClick={() => setService('growth')} /></Link>
                            </div>
                        </div>
                        <Routes>
                            <Route path='/development' element={<Development />} />
                            <Route path='/design' element={<Design />} />
                            <Route path='/growth' element={<Growth />} />
                        </Routes>
                    </div>
                </div>
            </Container>
        </div>
    )
}

function OfferingContainer({ children, data }: OfferingContainerProps) {
    return (
        <div className='rounded-[14px] shadow-xl px-3 md:px-6 xl:px-8 py-6 xl:py-10 3xl:p-20'>
            <div className="text-sm md:text-3xl md:leading-loose xl:text-[2.5rem] xl:leading-[64px] 3xl:text-5xl md:font-extrabold text-themeOrange">{children}</div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-y-10 md:gap-x-16 xl:gap-x-28 3xl:gap-y-16 3xl:gap-x-72 pt-6 md:pt-10">
                {
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((idx) => (
                        <div key={idx} className="space-y-4 xl:space-y-6">
                            <div className="flex items-center space-x-5 xl:space-x-6 3xl:space-x-8">
                                <div className="h-9 md:h-11 xl:h-14 3xl:h-[4.5rem] w-auto">
                                    <UXIcon className="h-full w-full" />
                                </div>
                                <div className="text-[#2A2A3E] text-sm md:text-base md:font-bold xl:text-2xl 3xl:text-[2rem] 3xl:leading-snug">User Experience Design (UX)</div>
                            </div>
                            <div className="text-[#2A2A3E] text-xs xl:text-lg md:leading-6 font-bold">
                                A design-first service to businesses, products and multiple platforms, we believe that collaboration is the true success. An elegant yet functional product is the perfect combination to approach the market with your vision.
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default Services